// extracted by mini-css-extract-plugin
export default {"wrapper":"UserApprove-modulewrapper-j9vtn"};